import {injectable, Inject} from 'inversify-props';
import HttpClient from "@/app/services/http-client";
import {INDIE_CONSTANTS} from "@/app/shared/common/constants";
import {Store} from "vuex";
import Helpers from "@/app/shared/common/helpers";
import Person from "@/app/shared/models/person.model";

@injectable()
export class CreditService {
    @Inject() httpClient: HttpClient;

    protected static isSelectedAirlineCreditOptionsRetrieved: boolean = false;
    protected static selectedAirlineCreditsPromise: Promise<any>;
    protected static isSelectedAirlineCreditDataRetrieved: boolean = false;
    protected static selectedAirlineCreditDataPromise: Promise<any>;

    public constructor() {

    }

    public readUrlParam(urlParamValue: string) {
        const body: any = {
            [INDIE_CONSTANTS.CREDIT_URL_QUERY_PARAM_NAME]: urlParamValue
        };
        //console.log(body);
        return this.httpClient.post("/search/read-credit-url-param", body);
    }

    public storeSelectedAirlineCredit(airlineCredit: any[], store: Store<any>) {
        const body: any = {
            "selected_credit_items": airlineCredit
        };
        return this.httpClient.post("/search/store-selected-airline-credit-options", body)
            .then((res) => {
                store.dispatch("storeSelectedAirlineCreditOptions", airlineCredit);
            });
    }

    public getSelectedAirlineCreditOptions(store: Store<any>) {
        if (CreditService.isSelectedAirlineCreditOptionsRetrieved === false) {
            CreditService.isSelectedAirlineCreditOptionsRetrieved = true;
            CreditService.selectedAirlineCreditsPromise = this.httpClient.post("/search/get-selected-airline-credit-options", {})
                .then((res) => {
                    const r = res.data.response;
                    const selectedAirlineCreditOptions = r.selected_airline_credit_options;
                    store.dispatch("storeSelectedAirlineCreditOptions", selectedAirlineCreditOptions);
                    return selectedAirlineCreditOptions;
                });/*.then(() => {
          console.log('sssaco');
          console.log(store.state.selectedAirlineCreditOptions);
          return store.state.selectedAirlineCreditOptions;
        })*/
        } /*else {
      return Promise.resolve().then(() => {
        return store.state.selectedAirlineCreditOptions;
      });
    }*/
        return CreditService.selectedAirlineCreditsPromise;
    }

    public getSelectedAirlineCreditData(store: Store<any>) {
        CreditService.isSelectedAirlineCreditDataRetrieved = true;
        CreditService.selectedAirlineCreditDataPromise = this.httpClient.post("/search/get-selected-airlines-credit-data", {})
            .then((res) => {
                const r = res.data.response;
                const selectedAirlineCreditData = r.selected_airlines_credit_data;
                store.dispatch("storeSelectedAirlineCreditData", selectedAirlineCreditData);
                return selectedAirlineCreditData;
            });
        return CreditService.selectedAirlineCreditDataPromise;
    }

    public getUsedAirlineCredit(store: Store<any>) {
        let usedCredit = store.state.usedCreditByAirline;
        console.log("uc");
        console.log(usedCredit);
        console.log(usedCredit.length);
        if (Helpers.isEmpty(usedCredit)) {
            console.log("is empty");
            usedCredit = false;
        } else {
            console.log("not empty");
        }
        return usedCredit;
    }

    public isInCreditFlow(store: Store<any>) {
        let usedCredit = store.state.usedCreditByAirline;
        if (usedCredit == false) {
            return false
        }
        return true;
    }

    public sendRebookDifferentMessageRequest(message: string, orderId: number) {
        let apexURL = process.env.VUE_APP_APEX_URL + `/#/order/${orderId}`;
        return this.httpClient.post("/book-different-route-request",
            {message: message + "<br /><br />\n\n" + apexURL}
        );
    }

    public getSelectedPassengersForCredit(store: Store<any>) {
        let passengers: any[] = [];
        if (store.state.selectedAirlineCreditOptions) {
            store.state.selectedAirlineCreditOptions.forEach((option: any) => {
                let person = new Person('A');
                person.name = store.state.creditData.credit_data.passengers_credit[option.person_id].name;
                person.surname = store.state.creditData.credit_data.passengers_credit[option.person_id].surname;
                person.gender = store.state.creditData.credit_data.passengers_credit[option.person_id].gender;
                person.birthDate = store.state.creditData.credit_data.passengers_credit[option.person_id].birthDate;
                passengers.push(person);
            });
        }
        return passengers;
    }

    public useCredit(store: Store<any>){
        let persons = this.getSelectedPassengersForCredit(store);
        let passengers: any = [];
        let passengersFields = ['name', 'surname', 'gender', 'birthDate'];
        persons.forEach( (person: any) => {
            let passenger: any = {};
            passengersFields.forEach( (field: string) => {
                passenger[field] = person[field];
            })
            passengers.push(passenger);
        })
        return this.httpClient.post("/use-credit",
            {
                order_id: store.state.creditData.credit_data.order_id,
                primary_contact: store.state.creditData.credit_data.primary_contact,
                billing_contact: store.state.creditData.credit_data.billing_contact,
                passengers: passengers,
                amount_due: store.state.totalCost,
                flights: store.state.selectedSegments
            }
        );
    }

}
